import type { PropostaItem } from '@/types'
import { isGalaxyPlanLabel } from '@/utils/planCatalogCore'
import { visibleProjectTypeLabel } from '@/utils/slideProjectTypeLabel'
import { recurringSetupEntry } from '@/utils/recurringSetupEntry'
import { normalizeSupportTiers } from '@/utils/planSuportePricing'

/** Garante estrutura mínima de pricing/escopo ao abrir o studio. */
export function hydrateProposalItems(initialItems: PropostaItem[]): PropostaItem[] {
  return initialItems.map((item) => {
    const copy = { ...item }

    if (!copy.descricao && copy.name) copy.descricao = copy.name
    if (!copy.name && copy.descricao) copy.name = copy.descricao
    if (!copy.nome && copy.descricao) copy.nome = copy.descricao
    copy.tipo = 'plano'

    let parsedDuration = Number(copy.duration)
    if (isNaN(parsedDuration) || parsedDuration <= 0) {
      parsedDuration = 12
    }
    copy.duration = parsedDuration

    if (copy.negotiationValidUntil) {
      copy.negotiationValidUntil = String(copy.negotiationValidUntil)
    }

    const planLabel = copy.descricao || copy.nome || copy.name || ''
    if (isGalaxyPlanLabel(planLabel)) {
      copy.projectType = ''
    } else {
      const desc = planLabel.toLowerCase()
      const isPlanoDeDesenvolvimento = desc.includes('site') || desc.includes('desenvolvimento')
      const current = visibleProjectTypeLabel(planLabel, copy.projectType)
      if (current) copy.projectType = current
      else if (isPlanoDeDesenvolvimento) copy.projectType = 'Plano de Desenvolvimento'
      else copy.projectType = ''
    }

    if (!copy.services || !Array.isArray(copy.services)) {
      copy.services = []
    }

    if (!copy.pricing || copy.pricing.recorrente === undefined) {
      copy.pricing = {
        total: Number(copy.pricing?.total || copy.valorUnitario * parsedDuration),
        entry: Number(copy.pricing?.entry || 0),
        installments: Number(copy.pricing?.installments || parsedDuration),
        installmentValue: Number(copy.pricing?.installmentValue || copy.valorUnitario),
        recorrente: true,
        supportPricingMode: copy.pricing?.supportPricingMode || 'FIXO_2000',
        monthlyFixedValue: Number(copy.pricing?.monthlyFixedValue ?? 2000),
        monthlyBaseValue: Number(copy.pricing?.monthlyBaseValue ?? 500),
        revenueSharePercent: Number(copy.pricing?.revenueSharePercent ?? 1),
        ...(copy.pricing?.supportHours != null ? { supportHours: Number(copy.pricing.supportHours) } : {}),
        ...(copy.pricing?.hourlyRate != null ? { hourlyRate: Number(copy.pricing.hourlyRate) } : {}),
        ...(normalizeSupportTiers(copy.pricing?.supportTiers).length >= 2
          ? { supportTiers: normalizeSupportTiers(copy.pricing?.supportTiers) }
          : {}),
      }
      copy.pricing.entry = recurringSetupEntry(copy.pricing)
    } else {
      copy.pricing = {
        total: Number(
          copy.pricing.total !== undefined
            ? copy.pricing.total
            : copy.valorUnitario * parsedDuration,
        ),
        entry: Number(copy.pricing.entry || 0),
        installments: Number(copy.pricing.installments || parsedDuration),
        installmentValue: Number(copy.pricing.installmentValue || copy.valorUnitario),
        recorrente: true,
        supportPricingMode: copy.pricing.supportPricingMode || 'FIXO_2000',
        monthlyFixedValue: Number(copy.pricing.monthlyFixedValue ?? 2000),
        monthlyBaseValue: Number(copy.pricing.monthlyBaseValue ?? 500),
        revenueSharePercent: Number(copy.pricing.revenueSharePercent ?? 1),
        ...(copy.pricing.supportHours != null ? { supportHours: Number(copy.pricing.supportHours) } : {}),
        ...(copy.pricing.hourlyRate != null ? { hourlyRate: Number(copy.pricing.hourlyRate) } : {}),
        ...(normalizeSupportTiers(copy.pricing.supportTiers).length >= 2
          ? { supportTiers: normalizeSupportTiers(copy.pricing.supportTiers) }
          : {}),
      }
      copy.pricing.entry = recurringSetupEntry(copy.pricing)
    }

    return copy
  })
}
